import { render, staticRenderFns } from "./GrinCardSignup.vue?vue&type=template&id=16ed7066&"
import script from "./GrinCardSignup.vue?vue&type=script&lang=js&"
export * from "./GrinCardSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports